import { useMemo } from "react";
import createSearch from "views/logic/slices/createSearch";
const useCreateSearch = (viewPromise) => useMemo(
  () => viewPromise.then(async (_view) => {
    await createSearch(_view.search);
    return _view;
  }),
  [viewPromise]
);
export default useCreateSearch;
